import Dispatcher from '../dispatcher';
import { CrossSellLightBoxActions } from '../constants/cross_sell_light_box/cross_sell_light_box_actions';

function showAction(payload) {
    Dispatcher.handleCrossSellLightboxAction({
        type: CrossSellLightBoxActions.SHOW,
        payload,
    });
}

function hideAction() {
    Dispatcher.handleCrossSellLightboxAction({
        type: CrossSellLightBoxActions.HIDE
    });
}

function expandAction() {
    Dispatcher.handleCrossSellLightboxAction({
        type: CrossSellLightBoxActions.EXPAND
    });
}

function crossSellInvalidAction(invalidMessage) {
    Dispatcher.handleCrossSellLightboxAction({
        type: CrossSellLightBoxActions.CROSS_SELL_INVALID_ACTION,
        payload: invalidMessage || getTranslatedText('message-invalid-request'),
    });
}

export {
    showAction,
    hideAction,
    expandAction,
    crossSellInvalidAction,
};
